import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      version="1.1"
      viewBox="0 0 234.667 165.333"
      xmlSpace="preserve"
    >
      <g transform="matrix(1.33333 0 0 -1.33333 0 165.333)">
        <g transform="scale(.1)">
          <path
            fill="#fff"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M700 358.313v523.375l460-261.7zm1023.22 688.057c-20.24 76.22-79.88 136.24-155.6 156.61C1430.37 1240 880 1240 880 1240s-550.367 0-687.621-37.02c-75.723-20.37-135.363-80.39-155.602-156.61C0 908.227 0 620 0 620s0-288.223 36.777-426.371C57.016 117.41 116.656 57.391 192.38 37.012 329.633 0 880 0 880 0s550.37 0 687.62 37.012c75.72 20.379 135.36 80.398 155.6 156.617C1760 331.777 1760 620 1760 620s0 288.227-36.78 426.37"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
